import { css } from "@stubhub/broadway-foundation/css";

export const backgroundColor = css({
  backgroundColor: "bg.surface.strong",
});

export const bodyWrapper = css({
  width: "full",
});

export const emailSignupWrapper = css({
  paddingInline: "primitives.200",
  tablet: {
    paddingInline: "primitives.0",
  },
  desktop: {
    paddingInline: "primitives.0",
  },
});

export const linkWrapper = css({
  textAlign: "center",
  display: "block",
  paddingBlock: "primitives.150",
});

export const searchLink = css({
  _hover: {
    textDecorationLine: "[underline]",
  },
});
